import "./style.css";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import {
    getQuotations
} from "../../../../../actions/auth/quotation";
import {
    getDetails,
} from "../../../../../actions/admin/quotation";
import { saveAs } from 'file-saver';
import { PDFViewer, pdf } from "@react-pdf/renderer";
import QuotationDocument from "../../../../../components/admin/quotation/_components/pdf/QuotationDocument"
import Spinner from "../../../../../components/layout/Spinner";
import { useTranslation } from "react-i18next";
import QuotationListFilter from "./_components/QuotationListFilter";
import { CopyAltIcon, DownloadNarrowIcon } from "../../../../../components/icons";

const Quotations = () => {
    const { t } = useTranslation();
    const [filterGetQuotations, setFilterGetQuotations] = useState({
        search: "",
        orderBy: "issueDate",
        sortBy: "desc"
    })
    const [debounced, setDebounced] = useState("");
    const [dataToPrint, setDataToPrint] = useState(null);
    const customerQuotation = useSelector((state) => state.customerQuotation);
    const { loading, customerQuotations } = customerQuotation;
    const dispatch = useDispatch();

    // Debounce effect
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebounced(filterGetQuotations);
        }, 500); // 500ms delay

        return () => {
            clearTimeout(handler);
        };
    }, [filterGetQuotations]);

    useEffect(() => {
        dispatch(getQuotations({
            orderBy: filterGetQuotations.orderBy,
            sortBy: filterGetQuotations.sortBy,
            search: filterGetQuotations.search,
        }));
    }, [dispatch, debounced]);

    const downloadButtonClickFunc = async (quotationId) => {
        var res = await getDetails(quotationId);
        if (res.bookings.length > 0 && res.quotationStatus !== "DRAFT") {

            const blob = await pdf((
                <QuotationDocument data={res} />
            )).toBlob();

            saveAs(blob, `TLF-INVOICE-${res?.quotationID}.pdf`);

        }
    };

    const onChangeFilter = (e) => {
        if (e.target.name === "sortBy") {
            setFilterGetQuotations({
                ...filterGetQuotations,
                orderBy: e.target.value.split(",")[0],
                sortBy: e.target.value.split(",")[1],
            })
        } else {
            setFilterGetQuotations({
                ...filterGetQuotations,
                [e.target.name]: e.target.value,
            })
        }
    }

    const getStatusQuotation = ({ paymentStatus, quotationStatus }) => {
        switch (quotationStatus) {
            case "DRAFT":
                return {
                    label: "Draft",
                    class: "status-draft"
                }

                break;
            case "ACTIVE":
                // Legacy PAID or any state of the new charge flow — the customer
                // has completed payment, so the quotation is booked.
                if (["PAID", "READY_TO_CHARGE", "CHARGE_INITIATED", "CHARGED", "CHARGE_FAILED"].includes(paymentStatus)) {
                    return {
                        label: "Booked",
                        class: "status-booked"
                    }
                } else {
                    return {
                        label: "Active",
                        class: "status-active"
                    }
                }

                break;

            case "EXPIRED":
                return {
                    label: "Expired",
                    class: "status-expired"
                }

                break;

            case "CANCELLED":
                return {
                    label: "Cancelled",
                    class: "status-cancelled"
                }

                break;


            default:
                break;
        }
    }

    return (
        <>
            <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] card-myPage tw:my-2">
                <div className="tw:flex-1 tw:p-4 tw:p-6">
                    <QuotationListFilter
                        onChangeFilter={onChangeFilter}
                        filterGetQuotations={filterGetQuotations}
                    />
                </div>
            </div>
            <div className="tw:p-0 tw:m-0">
                <div className="tw:block tw:w-full tw:overflow-x-auto tw:mb-6">
                    <table className="tw:w-full tw:mb-4 tw:align-top tw:border-collapse tw:text-[#212529] quotation-table tw:[&_tbody_tr:hover]:bg-[rgba(0,0,0,0.075)]">
                        <thead>
                            <tr>
                                <th scope="col">{t("myPage.quotation.table.clientName")}</th>
                                <th scope="col">{t("myPage.quotation.table.quotationNo")}</th>
                                <th scope="col">{t("myPage.quotation.table.amount")}</th>
                                <th scope="col">{t("myPage.quotation.table.status")}</th>
                                <th scope="col">{t("myPage.quotation.table.issueDate")}</th>
                                <th scope="col">{t("myPage.quotation.table.validUntil")}</th>
                                <th scope="col">{t("myPage.quotation.table.clientEmail")}</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                loading ? (
                                    <tr>
                                        <td colSpan={8}>
                                            <div className="tw:text-center" >
                                                <Spinner />
                                            </div>
                                        </td>
                                    </tr>
                                ) : customerQuotations?.recordsFiltered > 0 ? (
                                    customerQuotations?.data?.map((q, i = 0) => (
                                        <tr>
                                            <td>{q.user.name}</td>
                                            <td>{q.quotationID}</td>
                                            <td>{`${q.totalAmount.toLocaleString()} JPY`}</td>
                                            <td className={`${getStatusQuotation(q)['class']}`}>{`${getStatusQuotation(q)['label']}`}</td>
                                            <td>{moment(q?.issueDate).locale("en").format("MMM Do, YYYY")}</td>
                                            <td>{moment(q?.expiredDate).locale("en").format("MMM Do, YYYY")}</td>
                                            <td>{q.user.email}</td>
                                            <td className="tw:text-center tw:whitespace-nowrap">
                                                <button
                                                    className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-action btn-download-quotation"
                                                    title="Download"
                                                    onClick={() => downloadButtonClickFunc(q._id)}
                                                >
                                                    <DownloadNarrowIcon color="#FFFFFF" />
                                                </button>
                                                <button
                                                    className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-action btn-copy-quotation"
                                                    title="Delete"
                                                    onClick={() => {
                                                        const textToCopy = `${process.env.REACT_APP_URL}/quotation/${q._id}`;

                                                        navigator.clipboard
                                                            .writeText(textToCopy)
                                                            .then(() => {
                                                                alert("Quotation link copied to clipboard");
                                                            })
                                                            .catch((err) => {
                                                                console.error("Failed to copy text: ", err);
                                                            });
                                                    }}
                                                >
                                                    <CopyAltIcon />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={8}>
                                            <div className="tw:text-center" >
                                                There is no quotation...
                                            </div>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default Quotations;
